export const saleContract = "0x5ecbdfe189f9d271190bb233cc8d15889c7e7d48"; //"0xD4515A760aDb8ED22ca71cA908263973CD20d1bb";  //0x5ecbdfe189f9d271190bb233cc8d15889c7e7d48
export const tokenContract= "0x54017fda0ff8f380ccef600147a66d2e262d6b17"; //"0x37221cA8406E3A90639c6f0A454Cddf3Ba526fAF";  //0x54017fda0ff8f380ccef600147a66d2e262d6b17
export const nftV1 = "0xbee7514af0dc98c9042a601866f81d43c3e4063d";
export const lottery = "0xdA15Eb6f62b1F920CeF196eF3D8F0C1E579c64A8";

